module.exports = __webpack_public_path__ + "img/lt.1d701f43.svg";